/* eslint-disable react/forbid-prop-types,import/no-unresolved */
import React from 'react';
import PropTypes from 'prop-types';
import { MAIN_ICON_COLORS } from 'assets/components';
import CurrencyIcon from '../CurrencyIcon';
import Icon from '../Icon';
import { ICONS } from '../Icon/constants';
import { currencies } from '../../utilities/constants';

const WalletWithCheckbox = ({ children, walletIcon, handleSelect, isChecked, isCryptodraft }) => (
  <div
    className={`d-flex justify-content-between align-items-center p-3 wallet-item my-2 rounded w-100 cursor-pointer ${
      isChecked ? 'active_wallet-item' : ''
    }`}
    role="button"
    tabIndex={0}
    onKeyDown={() => {}}
    onClick={(e) => {
      if (e.target.querySelectorAll('.form-check-input').length > 0) {
        e.target.classList.toggle('active_wallet-item');
        e.target.querySelectorAll('.form-check-input')[0].click();
      }
    }}>
    {isCryptodraft && (
      <Icon
        icon={ICONS.CRYPTODRAFT}
        color={MAIN_ICON_COLORS.WHITE}
        fillColor={isChecked ? MAIN_ICON_COLORS.GRAY_LIGHTER : MAIN_ICON_COLORS.GRAY_LIGHT}
      />
    )}
    {!isCryptodraft && walletIcon.toUpperCase() !== currencies.XRP.icon && (
      <CurrencyIcon
        currencyCode={walletIcon}
        className="pe-none"
        style={{ width: '1.5rem', height: '1.5rem' }}
      />
    )}
    {walletIcon.toUpperCase() === currencies.XRP.icon && (
      <CurrencyIcon
        currencyCode={walletIcon}
        className="pe-none"
        style={{
          width: '1.5rem',
          height: '1.5rem',
          padding: '1px',
          backgroundColor: 'white',
          borderRadius: '20px',
        }}
      />
    )}

    <div className="ms-2 pe-none">{children}</div>
    <div className="d-flex form-check p-0 m-0 ms-auto pe-none">
      <input
        defaultChecked={isChecked}
        value="checked"
        onChange={(e) => handleSelect(e)}
        type="checkbox"
        className="form-check-input m-0 p-0 border-disabled"
      />
    </div>
  </div>
);
export default WalletWithCheckbox;

WalletWithCheckbox.propTypes = {
  children: PropTypes.any.isRequired,
  walletIcon: PropTypes.string,
  handleSelect: PropTypes.func.isRequired,
  isChecked: PropTypes.bool,
  isCryptodraft: PropTypes.bool,
};
WalletWithCheckbox.defaultProps = {
  walletIcon: null,
  isChecked: null,
  isCryptodraft: null,
};
